import * as React from 'react';
import { useSecret } from './useSecret';
import { useSecrets } from './useSecrets';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigContext = /*#__PURE__*/React.createContext(null);
function ConfigProvider(_ref) {
  let {
    children,
    infraApiUrl,
    initialSecrets,
    env = 'prod'
  } = _ref;
  const getSecret = React.useMemo(() => useSecret(infraApiUrl), [infraApiUrl]);
  const getSecrets = React.useMemo(() => useSecrets(infraApiUrl), [infraApiUrl]);
  //cache intial secrets
  if (initialSecrets) {
    getSecrets(initialSecrets);
  }
  const value = {
    getSecret,
    getSecrets,
    env
  };
  return /*#__PURE__*/_jsx(ConfigContext.Provider, {
    value: value,
    children: children
  });
}
let ConfigConsumer = ConfigContext.Consumer;
export { ConfigConsumer, ConfigContext, ConfigProvider };